'use strict';

angular.module('membership')
  .controller('UserManagerListSyncCtrl', [
    '$scope', '$compile', 'manageUsersListSyncViewModel', '$stateParams', 'membership.config',
    function ($scope, $compile, viewModel, $stateParams, config) {

      $scope.vm = new viewModel($stateParams.filter);
    }
  ]);